@if (isActive) {
  <div>
    <h2 mat-dialog-title>Deactivate this moov?</h2>
    <mat-dialog-content>
      <div class="mb-2">If you deactivate this moov:</div>
      <ol class="ml-5 mb-2">
        <li>It will no longer execute for any saved configuration</li>
        <li>All external links tied to this moov will become inactive</li>
      </ol>
      <div >To continue, click the Deactivate button below.</div>
    </mat-dialog-content>
  </div>
}
@else {
  <div [style.width.px]="600" [style.max-width]="600">
    <h2 mat-dialog-title>Reactivate this moov?</h2>
    <mat-dialog-content>
      <div class="mb-2">If you reactivate this moov:</div>
      <ol class="ml-5 mb-2">
        <li>Any saved configuration in active or testing mode will execute again</li>
        <li>All external links tied to this moov will become active</li>
      </ol>
      <div>To continue, click the Reactivate button below.</div>
    </mat-dialog-content>
  </div>
}
<mat-dialog-actions>
  <div class="mt-3 p-2 w-100 flex-row justify-end items-center">
    <a mat-button color="primary" (click)="onCancelClick()">{{cancelButtonText}}</a>
    <a mat-button color="primary" (click)="onSubmitClick()">{{submitButtonText}}</a>
  </div>
</mat-dialog-actions>